module.exports = __webpack_public_path__ + "d5a495267c4fc296ab6b52e375557e7b.png";